/*
 * Black Friday-pagina: countdown, fasecontrole in de browser en het
 * inschrijfformulier (Klaviyo).
 *
 * Tijden komen uit Thema-instellingen > Black Friday als Nederlandse tijd
 * ("JJJJ-MM-DD UU:MM") en worden hier omgerekend naar een vast moment, los van
 * de tijdzone van de bezoeker. De countdown is gebaseerd op
 * section-campaign-countdown.js (Dierendag), dat de klok van de bezoeker
 * gebruikte.
 *
 * Fasecontrole: Shopify kan een pagina enkele minuten bewaren. Klopt de fase in
 * de HTML niet (meer) met de klok, dan laadt de pagina één keer opnieuw met
 * ?bf=<fase> (een nieuwe URL, dus niet uit de bewaarde versie). Staat die
 * parameter er al, dan gebeurt niets meer: nooit een herlaad-lus.
 * De faseregels zijn gelijk aan snippets/bf-phase.liquid; houd die twee gelijk.
 */
(function () {
  'use strict';

  var HOUR = 60 * 60 * 1000;

  // Laatste zondag van een maand, 01:00 UTC: het EU-wisselmoment van zomertijd.
  function lastSundayUtc(year, monthIndex) {
    var lastDay = new Date(Date.UTC(year, monthIndex + 1, 0));
    var day = lastDay.getUTCDate() - lastDay.getUTCDay();
    return Date.UTC(year, monthIndex, day, 1);
  }

  // Verschil tussen Nederlandse tijd en UTC op een bepaald moment (1 of 2 uur).
  function nlOffset(utcMs) {
    var year = new Date(utcMs).getUTCFullYear();
    var summerStart = lastSundayUtc(year, 2);
    var summerEnd = lastSundayUtc(year, 9);
    return utcMs >= summerStart && utcMs < summerEnd ? 2 * HOUR : HOUR;
  }

  // "2026-10-31 00:00" (Nederlandse tijd) -> milliseconden sinds 1970, of NaN.
  function parseNl(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(String(value || '').trim());
    if (!m) return NaN;
    var wallClock = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    var summer = wallClock - 2 * HOUR;
    return nlOffset(summer) === 2 * HOUR ? summer : wallClock - HOUR;
  }

  var root = document.querySelector('[data-bf-phase-root]');
  var moments = null;
  var testMode = true;

  if (root) {
    testMode = root.getAttribute('data-test-mode') === 'true';
    moments = {
      lead: parseNl(root.getAttribute('data-moment-lead')),
      early: parseNl(root.getAttribute('data-moment-early')),
      sale: parseNl(root.getAttribute('data-moment-sale')),
      last: parseNl(root.getAttribute('data-moment-last')),
      end: parseNl(root.getAttribute('data-moment-end'))
    };
  }

  function expectedPhase(now) {
    if (now >= moments.end) return 'ended';
    if (now >= moments.last) return 'last';
    if (now >= moments.sale) return 'sale';
    if (now >= moments.early) return 'early';
    if (now >= moments.lead) return 'lead';
    return 'before';
  }

  var reloading = false;

  function checkPhase() {
    if (!root || testMode || reloading) return;
    var expected = expectedPhase(Date.now());
    if (expected === root.getAttribute('data-phase')) return;

    var url = new URL(window.location.href);
    if (url.searchParams.get('bf') === expected) return;
    url.searchParams.set('bf', expected);
    reloading = true;
    window.location.replace(url.toString());
  }

  function scheduleNextCheck() {
    if (!root || testMode) return;
    var now = Date.now();
    var next = Infinity;
    Object.keys(moments).forEach(function (key) {
      var t = moments[key];
      if (t > now && t < next) next = t;
    });
    var wait = next - now + 1000;
    // setTimeout accepteert maximaal ~24,8 dagen.
    if (wait < 2147483647) setTimeout(checkPhase, wait);
  }

  function pad(n) {
    return ('0' + n).slice(-2);
  }

  function startCountdown(el) {
    var target = parseNl(el.getAttribute('data-target'));
    if (isNaN(target)) {
      el.hidden = true;
      return;
    }
    var parts = {};
    ['days', 'hours', 'minutes', 'seconds'].forEach(function (unit) {
      parts[unit] = el.querySelector('[data-bf-cd="' + unit + '"]');
    });

    var timer = null;
    function update() {
      var diff = Math.max(0, target - Date.now());
      parts.days.textContent = Math.floor(diff / (24 * HOUR));
      parts.hours.textContent = pad(Math.floor((diff % (24 * HOUR)) / HOUR));
      parts.minutes.textContent = pad(Math.floor((diff % HOUR) / 60000));
      parts.seconds.textContent = pad(Math.floor((diff % 60000) / 1000));
      if (diff === 0) {
        if (timer) clearInterval(timer);
        checkPhase();
      }
    }
    update();
    timer = setInterval(update, 1000);
  }

  function initScrollLinks() {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-bf-scroll]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /*
   * Inschrijfformulier early access (sections/bf-lead.liquid) -> Klaviyo.
   * Openbare client-API: alleen de publieke sleutel, nooit een privésleutel.
   * https://developers.klaviyo.com/en/reference/create_client_subscription
   */
  var KLAVIYO_URL = 'https://a.klaviyo.com/client/subscriptions?company_id=';
  var KLAVIYO_REVISION = '2026-07-15';

  // "06 12 34 56 78" -> "+31612345678" (E.164), of '' als het geen geldig nummer is.
  function normalizePhone(raw, countryCode) {
    var digits = String(raw).replace(/[\s\-().\/]/g, '');
    if (digits.indexOf('00') === 0) digits = '+' + digits.slice(2);
    else if (digits.charAt(0) === '0') digits = countryCode.replace(/\s/g, '') + digits.slice(1);
    return /^\+[1-9]\d{7,14}$/.test(digits) ? digits : '';
  }

  /*
   * Meting: één event per geslaagde inschrijving, naar de tracking die al op
   * de site staat. Nooit e-mail, telefoon of andere persoonsgegevens.
   * - Google Tag Manager (GTM-PQW39WJH): dataLayer-event 'bf_early_access_signup'.
   *   In GTM koppelen aan GA4 (generate_lead) en/of een Google Ads-conversie.
   * - Meta Pixel: standaard-event 'Lead'.
   * - GA4 via gtag (alleen als gtag direct op de pagina staat; nu niet, dan via GTM).
   * - Microsoft Ads (UET): event 'bf_early_access_signup'.
   * - Shopify Customer Events: 'bf_early_access_signup' (voor eigen pixels).
   * Elke aanroep staat los, zodat een ontbrekende of haperende tool de rest
   * en de inschrijving zelf nooit blokkeert.
   */
  function trackSignup(detail) {
    var name = 'bf_early_access_signup';
    var calls = [
      function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, bf_pet: detail.pet, bf_language: detail.language, bf_source: detail.source });
      },
      function () {
        if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Black Friday 2026 early access', content_category: detail.pet });
      },
      function () {
        if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { lead_source: detail.source, bf_pet: detail.pet });
      },
      function () {
        if (window.uetq && typeof window.uetq.push === 'function') window.uetq.push('event', name, { event_category: 'lead', event_label: detail.pet });
      },
      function () {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, detail);
      }
    ];
    calls.forEach(function (call) {
      try {
        call();
      } catch (error) {}
    });
  }

  function initSignupForm(form) {
    var errorEl = form.querySelector('[data-bf-signup-error]');
    var successEl = document.getElementById(form.getAttribute('data-success-id'));
    var button = form.querySelector('button[type="submit"]');
    var sending = false;

    function clearError() {
      errorEl.hidden = true;
      errorEl.textContent = '';
      form.querySelectorAll('[aria-invalid]').forEach(function (el) {
        el.removeAttribute('aria-invalid');
      });
    }

    function showError(key, field) {
      errorEl.textContent = form.getAttribute('data-error-' + key);
      errorEl.hidden = false;
      if (field) {
        field.setAttribute('aria-invalid', 'true');
        field.focus();
      }
    }

    function showSuccess() {
      form.hidden = true;
      if (successEl) {
        successEl.hidden = false;
        successEl.focus();
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (sending) return;
      clearError();

      // Honeypot: bots vullen dit verborgen veld; doe alsof het lukte.
      if (form.elements.bf_website && form.elements.bf_website.value) {
        showSuccess();
        return;
      }

      var emailField = form.elements.email;
      var email = emailField.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return showError('email', emailField);

      var pet = form.querySelector('input[name="pet"]:checked');
      if (!pet) return showError('pet', form.querySelector('input[name="pet"]'));

      // Vraag "liever korting of cadeau" (alleen als die in het formulier staat).
      var pref = form.querySelector('input[name="pref"]:checked');
      if (form.querySelector('input[name="pref"]') && !pref) return showError('pref', form.querySelector('input[name="pref"]'));

      var phone = '';
      var phoneField = form.elements.phone;
      if (phoneField && phoneField.value.trim()) {
        phone = normalizePhone(phoneField.value, form.getAttribute('data-country-code') || '+31');
        if (!phone) return showError('phone', phoneField);
      }

      var properties = { taal: form.getAttribute('data-locale') };
      properties[form.getAttribute('data-pet-property') || 'huisdier'] = pet.value;
      if (pref) properties[form.getAttribute('data-pref-property') || 'voorkeur'] = pref.value;

      var profile = {
        email: email,
        properties: properties,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      };
      if (phone) {
        profile.phone_number = phone;
        profile.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
      }

      var attributes = { profile: { data: { type: 'profile', attributes: profile } } };
      var source = form.getAttribute('data-source');
      if (source) attributes.custom_source = source;

      var payload = {
        data: {
          type: 'subscription',
          attributes: attributes,
          relationships: { list: { data: { type: 'list', id: form.getAttribute('data-list-id') } } }
        }
      };

      // Klaviyo nog niet ingevuld (alleen zichtbaar in editor/preview).
      if (!form.getAttribute('data-public-key') || !form.getAttribute('data-list-id')) {
        return showError('generic');
      }

      sending = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      fetch(KLAVIYO_URL + encodeURIComponent(form.getAttribute('data-public-key')), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo ' + response.status);
          showSuccess();
          trackSignup({ pet: pet.value, preference: pref ? pref.value : '', language: form.getAttribute('data-locale'), source: source || 'bf2026-landingspagina' });
          // Voor de latere live inschrijfteller (zie BLACK_FRIDAY_BRIEF.md).
          document.dispatchEvent(new CustomEvent('bf:signup', { detail: { pet: pet.value } }));
        })
        .catch(function () {
          showError('generic');
        })
        .then(function () {
          sending = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
    });
  }

  /*
   * Binnenkomst-animaties (sections/bf-offer.liquid e.a.).
   * [data-bf-reveal] krijgt .is-visible zodra het in beeld komt (één keer);
   * de CSS doet de rest. [data-bf-count] telt het eerste getal in de tekst op
   * van 0 naar de ingestelde waarde. Bij prefers-reduced-motion of zonder
   * IntersectionObserver gebeurt niets en is alles direct zichtbaar.
   */
  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function prepareCount(el) {
    var original = el.textContent;
    var match = original.match(/\d+/);
    if (!match) return;
    el.setAttribute('data-bf-count-original', original);
    el.textContent = original.slice(0, match.index) + '0' + original.slice(match.index + match[0].length);
  }

  function runCount(el, delay) {
    var original = el.getAttribute('data-bf-count-original');
    if (original === null) return;
    var match = original.match(/\d+/);
    var target = parseInt(match[0], 10);
    var before = original.slice(0, match.index);
    var after = original.slice(match.index + match[0].length);
    var duration = 900;

    setTimeout(function () {
      var start = null;
      function step(now) {
        if (start === null) start = now;
        var progress = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - progress, 3);
        if (progress < 1) {
          el.textContent = before + Math.round(target * eased) + after;
          window.requestAnimationFrame(step);
        } else {
          el.textContent = original;
        }
      }
      window.requestAnimationFrame(step);
    }, delay);
  }

  function initReveal() {
    var items = document.querySelectorAll('[data-bf-reveal]');
    if (!items.length || prefersReducedMotion() || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('bf-motion');
    document.querySelectorAll('[data-bf-count]').forEach(prepareCount);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        el.classList.add('is-visible');
        // Gelijk laten lopen met het groeien van de balk (zie bf-page.css).
        el.querySelectorAll('[data-bf-count]').forEach(function (counter) {
          var index = parseFloat(window.getComputedStyle(counter).getPropertyValue('--bf-i')) || 0;
          runCount(counter, 450 + index * 220);
        });
      });
    }, { threshold: 0.2 });

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  /*
   * Shopsectie (sections/bf-shop.liquid): voortgangsbalk, tabs, zwevende
   * knop en compacte balk op mobiel.
   *
   * De balk rekent met snippets/bf-cart-state.liquid (JSON). Na elke
   * winkelwagenwijziging haalt hij die opnieuw op via de Section Rendering API
   * (?sections=bf-cart-state). Wijzigingen worden herkend aan elke fetch/XHR
   * naar /cart/add|change|update|clear (thema, drawer én apps) en aan het
   * event 'cart:refresh' dat het thema al gebruikt.
   */
  var CART_URL_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function watchCart(onChange) {
    if (window.fetch) {
      var originalFetch = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var request = originalFetch.apply(this, arguments);
        if (CART_URL_PATTERN.test(url)) request.then(onChange, onChange);
        return request;
      };
    }
    if (window.XMLHttpRequest) {
      var originalOpen = XMLHttpRequest.prototype.open;
      var originalSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.bfCartRequest = CART_URL_PATTERN.test(String(url));
        return originalOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (this.bfCartRequest) this.addEventListener('loadend', onChange);
        return originalSend.apply(this, arguments);
      };
    }
    document.addEventListener('cart:refresh', onChange);
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) onChange();
    });
  }

  // Shopify-geldnotatie, bijv. "€{{amount_with_comma_separator}}". Hele euro's zonder ",00".
  function formatMoney(cents, format) {
    function group(value, decimals, thousands, separator) {
      var parts = value.toFixed(decimals).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? separator + parts[1] : '');
    }
    var value = Math.max(0, cents) / 100;
    var template = (format || '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
    var key = (template.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1];
    var out;
    if (key === 'amount_no_decimals') out = group(value, 0, ',', '.');
    else if (key === 'amount_with_comma_separator') out = group(value, 2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') out = group(value, 0, '.', ',');
    else out = group(value, 2, ',', '.');
    if (cents % 100 === 0) out = out.replace(/[.,]00$/, '');
    return template.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  // Zet tekst met [bedrag] in een element; het bedrag wordt vet.
  function setAmountText(el, text, amount) {
    el.textContent = '';
    var parts = String(text).split(/\[(?:bedrag|amount)\]/);
    parts.forEach(function (part, index) {
      el.appendChild(document.createTextNode(part));
      if (index < parts.length - 1) {
        var strong = document.createElement('strong');
        strong.textContent = amount;
        el.appendChild(strong);
      }
    });
  }

  var CONFETTI_COLORS = ['#e25046', '#4eb33d', '#ffd84d', '#1f385a'];

  function celebrate(marker) {
    if (prefersReducedMotion()) return;
    marker.classList.remove('is-popping');
    void marker.offsetWidth; // animatie opnieuw starten
    marker.classList.add('is-popping');
    var dot = marker.querySelector('.bf-progress__dot');
    for (var i = 0; i < 14; i++) {
      var piece = document.createElement('span');
      var angle = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
      var distance = 28 + Math.random() * 30;
      piece.className = 'bf-confetti';
      piece.style.setProperty('--x', Math.round(Math.cos(angle) * distance) + 'px');
      piece.style.setProperty('--y', Math.round(Math.sin(angle) * distance - 12) + 'px');
      piece.style.setProperty('--r', Math.round(Math.random() * 360) + 'deg');
      piece.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      dot.appendChild(piece);
      setTimeout(piece.remove.bind(piece), 1100);
    }
  }

  function initProgress(bar) {
    var milestones, state;
    try {
      milestones = JSON.parse(bar.querySelector('[data-bf-milestones]').textContent);
      state = JSON.parse(bar.querySelector('[data-bf-cart-state]').textContent);
    } catch (error) {
      return;
    }

    var demoAttr = bar.getAttribute('data-demo');
    var demo = demoAttr ? parseInt(demoAttr, 10) : NaN;
    var isDemo = !isNaN(demo);
    var format = bar.getAttribute('data-money-format');
    var max = milestones[milestones.length - 1].amount || 1;
    var markers = Array.prototype.slice.call(bar.querySelectorAll('[data-bf-marker]'));
    var headline = bar.querySelector('[data-bf-progress-headline]');
    var gifts = bar.querySelector('[data-bf-progress-gifts]');
    var fill = bar.querySelector('[data-bf-progress-fill]');
    var total = bar.querySelector('[data-bf-progress-total]');
    var savings = bar.querySelector('[data-bf-progress-savings]');
    var mini = document.querySelector('[data-bf-progress-mini]');
    var miniText = mini && mini.querySelector('[data-bf-progress-mini-text]');
    var miniFill = mini && mini.querySelector('[data-bf-progress-mini-fill]');
    var previousUnlocked = null;
    var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

    // Desktop: balk op schaal (€0 tot laatste mijlpaal). Mobiel: mijlpalen op
    // gelijke afstand, vulling per stuk tussen twee mijlpalen (zie --pos-m).
    function fillPercent(amount) {
      if (!(mobileQuery && mobileQuery.matches)) return Math.min(100, (amount / max) * 100);
      var last = milestones.length - 1;
      for (var k = 0; k < last; k++) {
        var from = milestones[k].amount;
        var to = milestones[k + 1].amount;
        if (amount < to) return ((k + Math.max(0, amount - from) / (to - from || 1)) / last) * 100;
      }
      return 100;
    }

    function render() {
      var amount = isDemo ? demo : state.progress;
      var hasItems = isDemo || state.count > 0;
      var percent = fillPercent(amount) + '%';
      fill.style.width = percent;
      if (miniFill) miniFill.style.width = Math.min(100, (amount / max) * 100) + '%';

      var unlocked = [];
      markers.forEach(function (marker) {
        var on = hasItems && amount >= parseInt(marker.getAttribute('data-amount'), 10);
        marker.classList.toggle('is-unlocked', on);
        if (on) unlocked.push(marker);
      });

      var next = null;
      for (var i = 0; i < milestones.length; i++) {
        if (milestones[i].type !== 'start' && milestones[i].amount > amount) {
          next = milestones[i];
          break;
        }
      }

      markers.forEach(function (marker) {
        marker.classList.toggle('is-next', !!(hasItems && next && parseInt(marker.getAttribute('data-amount'), 10) === next.amount));
      });

      var text = bar.getAttribute('data-text-complete');
      var needed = '';
      if (!hasItems) text = bar.getAttribute('data-text-empty');
      else if (next) {
        text = next.goal;
        needed = formatMoney(next.amount - amount, format);
      }
      setAmountText(headline, text, needed);
      if (miniText) setAmountText(miniText, text, needed);

      gifts.textContent = '';
      if (hasItems && next && next.type === 'gift') {
        next.gifts.forEach(function (gift) {
          if (!gift.image) return;
          var img = document.createElement('img');
          img.src = gift.image;
          img.alt = gift.title;
          img.title = gift.title;
          img.width = 56;
          img.height = 56;
          img.loading = 'lazy';
          gifts.appendChild(img);
        });
      }

      total.textContent = formatMoney(isDemo ? demo : state.progress, format);
      if (!isDemo && state.savings > 0) {
        setAmountText(savings, bar.getAttribute('data-text-save'), formatMoney(state.savings, format));
        savings.hidden = false;
      } else {
        savings.hidden = true;
      }

      // Feestje alleen bij een nieuw behaalde mijlpaal, niet bij het laden.
      if (previousUnlocked !== null) {
        unlocked.forEach(function (marker) {
          if (previousUnlocked.indexOf(marker) === -1 && marker.getAttribute('data-amount') !== '0') celebrate(marker);
        });
      }
      previousUnlocked = unlocked;
    }

    var timer = null;
    function refresh() {
      if (isDemo) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + '?sections=bf-cart-state', { credentials: 'same-origin' })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            var holder = document.createElement('div');
            holder.innerHTML = data['bf-cart-state'] || '';
            state = JSON.parse(holder.textContent.trim());
            render();
          })
          .catch(function () {});
      }, 250);
    }

    render();
    watchCart(refresh);
    if (mobileQuery) {
      var onChange = function () {
        fill.style.transition = 'none';
        render();
        void fill.offsetWidth;
        fill.style.transition = '';
      };
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onChange);
      else if (mobileQuery.addListener) mobileQuery.addListener(onChange);
    }
  }

  function initTabs(shop) {
    var tabs = Array.prototype.slice.call(shop.querySelectorAll('[data-bf-tab]'));
    if (tabs.length < 2) return;

    function select(tab, focus) {
      tabs.forEach(function (other) {
        var on = other === tab;
        other.setAttribute('aria-selected', on ? 'true' : 'false');
        other.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        select(tab, false);
      });
      tab.addEventListener('keydown', function (event) {
        var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        select(tabs[(index + step + tabs.length) % tabs.length], true);
      });
    });
  }

  // Mobiel: zwevende knop (hero uit beeld, shop nog niet in beeld) en compacte
  // balk (in de shop, grote balk uit beeld). Zichtbaarheid regelt de CSS.
  function initShopHelpers(shop) {
    if (!('IntersectionObserver' in window)) return;
    var floatButton = document.querySelector('[data-bf-float]');
    var mini = shop.querySelector('[data-bf-progress-mini]');
    var hero = document.querySelector('.bf-hero');
    var bar = shop.querySelector('[data-bf-progress]');
    var seen = { hero: true, shop: false, bar: false };

    function update() {
      if (floatButton) floatButton.classList.toggle('is-shown', !seen.hero && !seen.shop);
      if (mini) mini.classList.toggle('is-shown', seen.shop && !seen.bar);
    }

    function watch(el, key) {
      if (!el) return;
      new IntersectionObserver(function (entries) {
        seen[key] = entries[entries.length - 1].isIntersecting;
        update();
      }).observe(el);
    }

    watch(hero, 'hero');
    watch(shop, 'shop');
    watch(bar, 'bar');
  }

  // Keuzemenu voor producten met varianten (snippets/bf-shop-item.liquid):
  // in de kaart boven "Voeg toe" zetten en de gekozen variant aan de knop geven.
  function initVariantSelects(root) {
    root.querySelectorAll('[data-bf-variant-select]').forEach(function (select) {
      var item = select.closest('.bf-shop__item');
      var button = item && item.querySelector('cart-add-button');
      if (!button) return;
      button.parentElement.insertBefore(select, button);
      function sync() {
        button.setAttribute('data-id', select.value);
      }
      select.addEventListener('change', sync);
      sync();
    });
  }

  function initShop() {
    var shop = document.querySelector('[data-bf-shop]');
    if (!shop) return;
    var bar = shop.querySelector('[data-bf-progress]');
    if (bar) initProgress(bar);
    initTabs(shop);
    initShopHelpers(shop);
    initVariantSelects(shop);
  }

  /*
   * Inschrijfteller en recente inschrijvingen (sections/bf-lead.liquid),
   * handmatig bijgehouden in de editor: "hoe lang geleden" wordt getoond zoals
   * het is ingevuld (getal + minuten/uren/dagen). Meest recente eerst;
   * inschrijvingen van langer dan "maximaal … dagen" geleden worden niet getoond.
   */
  var AGO_MINUTES = { minutes: 1, hours: 60, days: 1440 };

  function agoText(box, value, unit) {
    var n = Math.max(0, Math.round(value));
    if (n === 0) return box.getAttribute('data-time-now');
    if (unit === 'days') return n === 1 ? box.getAttribute('data-time-day') : box.getAttribute('data-time-days').replace('[n]', n);
    if (unit === 'hours') return n === 1 ? box.getAttribute('data-time-hour') : box.getAttribute('data-time-hours').replace('[n]', n);
    return n === 1 ? box.getAttribute('data-time-minute') : box.getAttribute('data-time-minutes').replace('[n]', n);
  }

  function initSignupSocial(box) {
    var locale = box.getAttribute('data-locale') === 'nl' ? 'nl-NL' : 'en-GB';
    var countEl = box.querySelector('[data-bf-signup-count]');
    var recentEl = box.querySelector('[data-bf-recent]');
    var count = countEl ? parseInt(countEl.getAttribute('data-value'), 10) || 0 : 0;
    var template = box.getAttribute('data-text-recent') || '';
    var maxMinutes = (parseInt(box.getAttribute('data-max-days'), 10) || 7) * 1440;
    var entries = [];
    try {
      entries = JSON.parse((box.querySelector('[data-bf-recent-list]') || {}).textContent || '[]');
    } catch (error) {}
    entries = entries
      .map(function (entry) {
        var value = parseFloat(entry.ago);
        var unit = AGO_MINUTES[entry.unit] ? entry.unit : 'minutes';
        return { name: entry.name, pet: entry.pet || '', value: value, unit: unit, minutes: value * AGO_MINUTES[unit] };
      })
      .filter(function (entry) {
        return entry.name && !isNaN(entry.value) && entry.value >= 0 && entry.minutes <= maxMinutes;
      })
      .sort(function (a, b) {
        return a.minutes - b.minutes;
      });

    function format(n) {
      return n.toLocaleString(locale);
    }

    function line(entry) {
      return template
        .replace(/\[(naam|name)\]/g, entry.name)
        .replace(/\[(dier|pet)\]/g, entry.pet)
        .replace(/\[(tijd|time)\]/g, agoText(box, entry.value, entry.unit))
        .replace(/\s+/g, ' ')
        .trim();
    }

    function show(text) {
      if (!recentEl) {
        recentEl = document.createElement('p');
        recentEl.className = 'bf-lead__recent';
        recentEl.setAttribute('aria-live', 'polite');
        box.appendChild(recentEl);
      }
      recentEl.classList.remove('is-in');
      void recentEl.offsetWidth;
      recentEl.textContent = text;
      recentEl.hidden = false;
      recentEl.classList.add('is-in');
    }

    var index = 0;
    var timer = null;
    if (entries.length) {
      show(line(entries[0]));
      if (entries.length > 1 && !prefersReducedMotion()) {
        timer = setInterval(function () {
          index = (index + 1) % entries.length;
          show(line(entries[index]));
        }, 5000);
      }
    } else if (recentEl) {
      recentEl.hidden = true;
    }
    if (!countEl && !entries.length) box.hidden = true;

    // Teller telt op zodra hij in beeld komt (één keer).
    if (countEl && count > 0 && !prefersReducedMotion() && 'IntersectionObserver' in window) {
      countEl.textContent = format(0);
      var observer = new IntersectionObserver(function (items) {
        if (!items[0].isIntersecting) return;
        observer.disconnect();
        var target = count;
        var start = null;
        function step(time) {
          if (start === null) start = time;
          var progress = Math.min(1, (time - start) / 1200);
          countEl.textContent = format(Math.round(target * (1 - Math.pow(1 - progress, 3))));
          if (progress < 1) window.requestAnimationFrame(step);
          else countEl.textContent = format(count);
        }
        window.requestAnimationFrame(step);
      }, { threshold: 0.3 });
      observer.observe(countEl);
    }

    // Eigen inschrijving: +1 en "Jij schreef je zojuist in".
    document.addEventListener('bf:signup', function () {
      box.hidden = false;
      if (countEl) {
        count += 1;
        countEl.setAttribute('data-value', count);
        countEl.textContent = format(count);
      }
      if (timer) clearInterval(timer);
      show(box.getAttribute('data-text-self'));
    });
  }

  function init() {
    initShop();
    checkPhase();
    scheduleNextCheck();
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') checkPhase();
    });
    document.querySelectorAll('[data-bf-countdown]').forEach(startCountdown);
    document.querySelectorAll('[data-bf-signup]').forEach(initSignupForm);
    document.querySelectorAll('[data-bf-signup-social]').forEach(initSignupSocial);
    initScrollLinks();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
